export const processPhoneNumber = (phone, countryCode) => {
  const normalized = `${phone}`
    .replace(/\s+/g, "")
    .replace(/^0+/, "")
    .replace("+", "");

  const code = `${countryCode}`.replace("+", "");

  if (normalized.startsWith(code)) {
    return `${countryCode} ${normalized.slice(code.length)}`;
  }

  return `${countryCode} ${`${phone}`.replace("+", "")}`;
};
